import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { OfficeAction, ProfileAction } from '../../store/actions';

class SwitchOffice extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    getOffices: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
    permissions: PropTypes.arrayOf(PropTypes.string),
    switchOffice: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount() {
    if (this.props.permissions?.includes?.('profile.switch_office')) {
      this.props.getOffices();
    }
  }

  getInitialState() {
    const officeId = [this.props.authOfficeId, '']?.find?.(i => i);
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      '',
    ]?.find?.(i => i);
    return {
      office_id: officeId || '',
      office_selected: officeSelected || '',
    };
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.switchOffice(this.state);
  }

  render() {
    return this.props.permissions?.includes?.('profile.switch_office') ? (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Switch Office</h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="office_id">Office</label>
                    <Select
                      id="office_id"
                      name="office_selected"
                      onChange={(option, action) =>
                        this.onSelect(option, { ...action, _name: 'office_id' })
                      }
                      onInputChange={value => {
                        value && this.props.getOffices({ query: value });
                      }}
                      options={this.props.offices}
                      placeholder="Select Office"
                      value={this.state.office_selected}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Switch
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  offices: [{ label: 'All Office', value: '' }]?.concat?.(
    state?.office?.list?.data?.map?.(row => ({
      label: row.name,
      value: row.id,
    })),
  ),
  permissions: state?.auth?.permissions,
});

const mapDispatchToProps = dispatch => ({
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
  switchOffice: data => dispatch(ProfileAction.switchOffice(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SwitchOffice);
